import { useToast } from 'vue-toastification';
import deviceService from '../../services/deviceService';

const toast = useToast();

export default {
  namespaced: true,
  state: {
    devices: undefined,
    selectedDevice: undefined,
  },
  mutations: {
    CLEAR_STORE(state) {
      state.devices = undefined;
      state.selectedDevice = undefined;
    },
    CLEAR_DEVICES(state) {
      state.devices = undefined;
    },
    CLEAR_SELECTED_DEVICE(state) {
      state.selectedDevice = undefined;
    },
    SET_DEVICES(state, devices) {
      state.devices = devices;
    },
    SET_SELECTED_DEVICE(state, Device) {
      state.selectedDevice = Device;
    },
  },
  actions: {
    async getAllDevices({ commit }, params) {
      await deviceService
        .getAll(params)
        .then((response) => {
          commit('SET_DEVICES', response);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async getAllSortedDevices({ commit }, params) {
      await deviceService
        .getAll(params)
        .then((response) => {
          response.sort((a, b) => a.name.localeCompare(b.name));
          commit('SET_DEVICES', response);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async getDeviceById({ commit }, id) {
      await deviceService
        .getById(id)
        .then((response) => {
          commit('SET_SELECTED_DEVICE', response);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async getPaginateDevices({ commit }, { page, params }) {
      await deviceService
        .paginate(page, params)
        .then((response) => {
          commit('SET_DEVICES', response);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async createDevice(state, data) {
      await deviceService
        .create(data)
        .then(() => {
          toast.success('Device cadastrada');
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async updateDevice(state, { data, id }) {
      await deviceService
        .update({ data, id })
        .then(() => {
          toast.success('Device atualizada');
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
    async deleteDevice(state, id) {
      await deviceService
        .delete(id)
        .then(() => {
          toast.success('Device deletada');
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        });
    },
  },
  modules: {},
  getters: {},
};
